import { Button, Icon, Modal } from "@wisr/react-ui";
import React from "react";

import style from "./support-modal.scss";
import { BRAND_WEBSITE } from "../../shared/url.consts";

interface PropTypes {
  supportModal: boolean;
  setSupportModal: (arg0: boolean) => void;
}

export const SupportModal: React.FC<PropTypes> = ({
  supportModal,
  setSupportModal,
}) => {
  return (
    <Modal
      titleText="Need help?"
      open={supportModal}
      onClose={/* istanbul ignore next */ () => setSupportModal(false)}
    >
      <div className="support-list">
        <style jsx>{style}</style>
        <p>
          Our customer support team is available Monday to Friday, 9am - 5pm
          AEST.
        </p>
        <a
          className="support-item"
          href={`${BRAND_WEBSITE}/contact-us?subject=Loans`}
          rel="noreferrer"
          target="_blank"
        >
          <div className="icon">
            <Icon name="action-email" size="md" legacy={false} />
          </div>{" "}
          Contact us
        </a>
        <hr />
        <a className="support-item" href="tel:1300992007">
          <div className="icon">
            <Icon name="action-phone" size="md" legacy={false} />
          </div>{" "}
          Call us
        </a>
        <hr />
        <a
          className="support-item"
          href={`${BRAND_WEBSITE}/help-categories/personal-loans`}
          rel="noreferrer"
          target="_blank"
        >
          <div className="icon">
            <Icon name="action-help" size="md" legacy={false} />
          </div>{" "}
          FAQs
        </a>
      </div>
      <Button theme="navy" fullWidth={true}>
        <button type="button" onClick={() => setSupportModal(false)}>
          Close
        </button>
      </Button>
    </Modal>
  );
};
